import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Leads() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/searches?tab=leads', { replace: true });
  }, [navigate]);

  return null;
}
